import React from "react";

const StyledLgText = ({ children, font }) => {
  return (
    <p className={`text-lg font-star-jedi lowercase leading-[150%] ${font}`}>
      {children}
    </p>
  );
};

export default StyledLgText;
